import { render, staticRenderFns } from "./announcement_detail.vue?vue&type=template&id=7ada7aa4&scoped=true&"
import script from "./announcement_detail.vue?vue&type=script&lang=js&"
export * from "./announcement_detail.vue?vue&type=script&lang=js&"
import style0 from "./announcement_detail.vue?vue&type=style&index=0&id=7ada7aa4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ada7aa4",
  null
  
)

export default component.exports